const type = 'SET_SPENDING_LIMIT_CHANNEL';

const setSpendingLimitChannel = (data) => ({
  data,
  type,
});

export { type };
export default setSpendingLimitChannel;
